import React, { useState, useEffect, memo } from "react";
import { Text, View, Page, Document, PDFViewer } from '@react-pdf/renderer';
import { getAnimals, getAnimalsByGender, getOwner } from "../../api/index.js";
import { useLocation } from "react-router-dom";
import Spinner from "../../components/Spinner.js";
import "../../components/pdf/Fonts.js"
import styles from "../../components/pdf/Styles.js"

const AnimalsPdf = () => {
    const [animals, setAnimals] = useState([]);
    const [animalOwner, setAnimalOwner] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = async (ownerId, sex) => {
        setIsLoading(true);
        const animalsPromise = sex !== "all" ? getAnimalsByGender(ownerId, sex) : getAnimals(ownerId);
        const ownerPromise = getOwner(ownerId);
        const [{ animals }, { owner }] = await Promise.all([animalsPromise, ownerPromise]);
        setAnimals(animals);
        setAnimalOwner(owner);
        setIsLoading(false);
    };


    const location = useLocation();
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const sex = params.get("sex");
        const ownerId = params.get("owner");
        fetchData(ownerId, sex);
    }, []);

    const formatDate = (date) => {
        return date ? new Date(date).toLocaleDateString("el-GR") : null;
    };

    return (
        <>
            <Spinner open={isLoading} />
            <PDFViewer style={{ width: '99%', height: '100vh' }}>
                <Document>
                    <Page size='A4' orientation='landscape' style={styles.page} wrap>
                        <View style={styles.topColumn} fixed>
                            <View style={styles.headers_container}>
                                <Text style={styles.headers}>{'Ετικέτα'}</Text>
                                <Text style={styles.headers}>{'Φύλο'}</Text>
                                <Text style={styles.headers}>{'Ημ/νία Γέννησης'}</Text>
                                <Text style={styles.headers}>{'Εκτροφή'}</Text>
                                <Text style={styles.headers}>{'Αιτία Απομάκρυνσης'}</Text>
                                <Text style={styles.headers}>{'Ημ/νία Απομάκρυνσης'}</Text>
                                <Text style={styles.headers}>{'Φυλή'}</Text>
                            </View>
                        </View>
                        <View style={styles.bottomColumns}>
                            {animals.map((item) =>
                                <View key={item._id} style={styles.cells_container} wrap={false}>
                                    <Text style={styles.cell}>{item?.registrationCode}</Text>
                                    <Text style={styles.cell}>{item?.sex}</Text>
                                    <Text style={styles.cell}>{formatDate(item?.birthDate)}</Text>
                                    <Text style={styles.cell}>{`${animalOwner?.lastName} ${animalOwner?.firstName}`}</Text>
                                    <Text style={styles.cell}>{item?.cullingCode}</Text>
                                    <Text style={styles.cell}>{formatDate(item?.cullingDate)}</Text>
                                    <Text style={styles.cell}>{item?.breedCode}</Text>
                                </View>
                            )}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        </>
    );
};

export default memo(AnimalsPdf);
